/* eslint-disable no-restricted-syntax */
/* eslint-disable no-await-in-loop */
/* eslint-disable function-paren-newline */
import React, { createContext, useEffect, useState } from 'react';
import { Dialog, FlatButton, RaisedButton } from 'material-ui';
import FailedToSentTable from './FailedToSentTable';
import styled from 'styled-components';

export const FailedTwinsContext = createContext({
    failedTwins: /** @type {FailedTwin[]} */ ([]),
    setFailedTwins: /** @type {React.Dispatch<React.SetStateAction<(FailedTwin & UpdateStatuses & Selections)[]>>} */ (() => {}),
});

/**
 * @param {{
 *  open: boolean
 *  failedTwinsList: (FailedTwin & UpdateStatuses)[],
 *  handleToggleDialog: () => void,
 *  disabled: boolean,
 *  sendRequest: Function,
 * }} param0 
 * @returns 
 */
export default function FailedToSent({
    open, failedTwinsList, handleToggleDialog, disabled, 
    sendRequest,
}) {
    const [failedTwins, setFailedTwins] = useState(failedTwinsList);

    useEffect(() => { 
        setFailedTwins(failedTwinsList);
    }, [failedTwinsList]);

    const actions = [
        <FlatButton
            label='Close'
            primary
            onClick={handleToggleDialog}
        />,
    ];

    const calculateAmount = (amount) => {
        if (amount >= 10) return '9+';
        return amount;
    };

    const sendOne = async (index) => {
        setFailedTwins((prevFailedTwins) => {
            const updatedTwins = [...prevFailedTwins];
            updatedTwins[index].status = 'pending';
            return updatedTwins;
        });
        const result = await sendRequest(failedTwins[index]);
        
        setFailedTwins((prevFailedTwins) => {
            const updatedTwins = [...prevFailedTwins];
            updatedTwins[index].status = result[0].status;
            updatedTwins[index].message = result[0].message;
            updatedTwins[index].refNos = Array.from(new Set(result.map(r => r.refNo)));
            return updatedTwins;
        });
    };

    const sendAll = async () => {
        for (const index of Object.keys(failedTwinsList)) {
            await sendOne(index);
        }
    };

    return (
        <React.Fragment>
            <StyledDialog
                open={open}
                actions={actions}
                onRequestClose={handleToggleDialog}
                contentStyle={{
                    maxWidth: 'unset',
                }}
            >
                <StyledCaution>Current request data will be applied to other emails, proceed with caution.</StyledCaution>
                <FailedTwinsContext.Provider value={{ failedTwins, setFailedTwins }}>
                    <FailedToSentTable sendRequest={sendOne} />
                </FailedTwinsContext.Provider>
                <StyledButtonCont>
                    <RaisedButton label='send all' primary onClick={sendAll} />
                </StyledButtonCont>
            </StyledDialog>

            <RaisedButton
                labelStyle={{ fontSize: '10px' }}
                style={{ height: '25px' }}
                buttonStyle={{ height: '25px', lineHeight: '25px' }}
                label={`Failed twins (${calculateAmount(failedTwinsList.length || 0)})`}
                primary
                onClick={handleToggleDialog}
                disabled={disabled || !failedTwinsList.length}
            />
        </React.Fragment>
    );
}

/**
 * @typedef {Object} FailedTwin
 * @property {string} _id
 * @property {string} subject
 * @property {{ _id: string, email: string }} owner
 * @property {IContext} context
 * @property {string} realUserEmail
 * @property {string[]} [refNos]
 */

/**
 * @typedef {Object} UpdateStatuses
 * @property {'success' | 'error' | 'pending'} status
 * @property {string} message
 */

const StyledDialog = styled(Dialog)`
    max-width: unset;
`;

const StyledCaution = styled.h2`
    color: indianred;
    text-align: center;
`;

const StyledButtonCont = styled.div`
    margin-top: 25px;
    display: flex;
    flex-direction: row-reverse;
    margin-right: 36px;
`;



// WEBPACK FOOTER //
// ./app/components/Letters/common/FailedToSent.jsx